/* eslint-disable react/prop-types */
import classes from "./page-type-three.module.scss";

import Flex from "@/components-library/layout/flex";
import ComposedViewHeader from "@/composed-views/composed-view-header";
import ComposedViewSix from "@/composed-views/composed-view-six";
import ComposedViewInfiniteCarousel from "@/composed-views/composed-view-infinite-carousel";
import { FACILITATIONS } from "@/static-texts/facilitations";
import CardViewService from "@/composed-views/card-view-service";
import ComposedViewTen from "@/composed-views/composed-view-ten";
import ComposedViewEleven from "@/composed-views/composed-view-eleven";

function PageTypeThree({ content, Table }) {
  return (
    <Flex
      align="flex-start"
      className={classes.container}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader
        header={content.header.header}
        title={content.header.title}
        subTitle={content.header.subTitle}
      />

      <ComposedViewSix
        header={content.capitalGoods.header}
        title={content.capitalGoods.title}
        columnOneTitle={content.capitalGoods.columnOneTitle}
        columnOne={content.capitalGoods.columnOne}
        columnTwoTitle={content.capitalGoods.columnTwoTitle}
        columnTwo={content.capitalGoods.columnTwo}
        subContent={content.capitalGoods.subContent}
        className={classes.capitalGoods}
      />

      <ComposedViewTen
        title={content.table.title}
        content={content.table.content}
        subContentTitle={content.table.subContentTitle}
        subContent={content.table.subContent}
        subContent2Title={content.table.subContent2Title}
        subContent2={content.table.subContent2}
        Table={Table}
      />

      {content.pdf && (
        <ComposedViewEleven
          title={content.pdf?.title}
          link={content.pdf?.link}
        />
      )}

      <ComposedViewInfiniteCarousel
        title={content.services.title}
        subTitle={content.services.subTitle}
        items={Object.keys(FACILITATIONS).map((key) => FACILITATIONS[key])}
        itemType={<CardViewService size={"md"} />}
      />
    </Flex>
  );
}

export default PageTypeThree;
